export const API_BASE_URL = "https://webadmin.westendjewellery.com";
export const Image_URL = "https://westendjewellery.com/assets/Images/";
export const Web_Image_URL = "https://westendjewellery.com/assets/";
export const Custom_API_URL = "https://webadmin.westendjewellery.com"; //https://webadmin.westendjewellery.com
/*
|--------------------------------------------------------------------------
| ACCESS CONFIGURATION (FULLY FIXED)
|--------------------------------------------------------------------------
*/

export const accessConfig = {
  // FULL ACCESS
  "Both": ["*"],

  // CUSTOMIZATION ONLY
  "Customization": [
    "/productCustomization",
    "/customiseorder",
    "/customiseorderlist",
    "/customiseproduct",
     "/partneraccount",
    "/partnerdashboard",
    "/about",
    "/blog",
    "/blogDetails",
    "/contactus",
    "/faq",
    "/finance",
    "/freeResize",
    "/privacyPolicy",
    "/shippingPolicy",
    "/returns",
    "/return",
    "/requestforpriceview",
      "/carrycart",
       "/carrycheckout",
       "/stockcarry",
        "/productgroup",
        
  ],

  // OMNICHANNEL (NOT FULL)
  "Omnichannel": [
    "/products",
    "/productdetails",
    "/cart",
    "/checkout",
    "/wishlist",
    "/partnerdashboard",
    "/partneraccount",
    "/orders",
    "/orderdetails",    
    "/about",
    "/blog",
    "/blogDetails",
    "/contactus",
    "/faq",
    "/finance",
    "/freeResize",
    "/privacyPolicy",
    "/shippingPolicy",
    "/returns",
    "/return",
     "/Requestforpriceview",
     "/Requestpricedetails",
      "/carrycart",
       "/carrycheckout",
       "/stockcarry",
       "/productgroup",
      
  ]
};

